import React, { useEffect, useState, useContext } from "react";
import axios from "axios";
import { AuthContext } from "../context/AuthContext";
import './Orders.css'

const Orders = () => {
  const { user } = useContext(AuthContext);
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchOrders = async () => {
      if (!user) return;
      try {
        const token = user.token || localStorage.getItem("token");
        const res = await axios.get("/orders", {
          headers: { Authorization: `Bearer ${token}` },
        });
        // إذا أردت عرض فقط طلبات المستخدم الحالي
        const userOrders = res.data.filter((o) => o.userId === user._id);
        setOrders(userOrders);
      } catch (err) {
        setError(err.response?.data?.message || err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchOrders();
  }, [user]);

  if (!user) return <p>Please log in to see your orders.</p>;
  if (loading) return <p>Loading orders...</p>;
  if (error) return <p style={{ color: "red" }}>{error}</p>;

  return (
    <div className="orders">
      <h1>My Orders</h1>
      {orders.length === 0 ? (
        <p>You have no reservations yet.</p>
      ) : (
        <table>
          <thead>
            <tr>
              <th>Order ID</th>
              <th>Property</th>
              <th>Rooms</th>
              <th>Amount</th>
              <th>Status</th>
              <th>Date</th>
            </tr>
          </thead>
          <tbody>
            {orders.map((order) => (
              <tr key={order._id}>
                <td>{order._id}</td>
                <td>{order.address.hotel}</td>
                <td>{order.products.map((p) => p.productId).join(", ")}</td>
                <td>${order.amount}</td>
                <td>{order.status}</td>
                <td>{new Date(order.createdAt).toLocaleDateString()}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default Orders;
